import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ReportType/";

const getReports = async (isAutomated) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportTypes?isAutomated=' + isAutomated, constants.REQUIRE_INTERCEPTORS);

export {
    getReports,
}